import { css } from "@emotion/react";
import Theme from "../../Theme/client";
import { colorPerDisplay, FieldDisplay } from "./display";
import T from "@hpo/client/components/text/Text";
import Spinner from "@hpo/client/components/Spinner";

export type FieldLabelProps = {
  text?: string;
  htmlFor?: string;
  showRequiredSymbol?: boolean;
  display?: FieldDisplay;
  loading?: boolean;
};

export default function FieldLabel(props: FieldLabelProps) {
  const {
    htmlFor,
    text,
    showRequiredSymbol,
    display = "normal",
    loading,
  } = props;

  const labelWrapperStyle = css({
    display: "flex",
    alignItems: "center",
  });

  const labelStyle = css({
    color: colorPerDisplay[display],
    flex: 1,
    alignItems: "center",
    whiteSpace: "nowrap",
    minWidth: 0,
    textOverflow: "ellipsis",
    overflow: "hidden",
  });

  const spinnerStyle = css({
    opacity: loading ? 1 : 0,
    transition: "all 150ms",
  });

  return (
    <div css={labelWrapperStyle}>
      <label htmlFor={htmlFor} css={labelStyle}>
        <T>
          {text}
          {showRequiredSymbol ? "*" : ""}
        </T>
      </label>
      {loading !== undefined ? (
        <div css={spinnerStyle}>
          <Spinner color={Theme.color} />
        </div>
      ) : null}
    </div>
  );
}
